var map = {
	"./slide-8-1.jpg": "101f",
	"./slide-8-2.jpg": "c05b",
	"./slide-8-3.jpg": "72f1",
	"./slide-8-4.jpg": "2798",
	"./slide-8-5.jpg": "ac5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ebc";